import { isNil, toString } from 'lodash-es';
import type { DeviceCallScheduling } from '../../domain/models/deviceInfo.model';

export function formatTimeWindow(time?: string): string {
  if (!time) {
    return '-';
  }

  return time; // Time is already formatted from the API call.
}

export function formatCallWindow(callScheduling?: DeviceCallScheduling): string {
  const startTime = formatTimeWindow(callScheduling?.startTimeWindow);
  const endTime = formatTimeWindow(callScheduling?.endTimeWindow);

  return startTime === '-' || endTime === '-' ? '-' : `${startTime} - ${endTime}`;
}

export function getNextCallValues(nextCallDate?: string): {
  readonly nextCallDateRaw: string;
  readonly nextCallDateUserFormatted: string;
} {
  if (isNil(nextCallDate)) {
    return {
      nextCallDateRaw: '-',
      nextCallDateUserFormatted: '-',
    };
  }

  const nextCallDateRaw = toString(nextCallDate);

  return {
    nextCallDateRaw,
    // Keep untouched for now. This variable is intentionally created for future user-format conversion needs.
    nextCallDateUserFormatted: nextCallDateRaw,
  };
}
